var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunicareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#003057;}.cls-2{fill:#729bc7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.4292,20.8472v7.4045c0,.5679-.6749,1.0315-1.5061,1.0315h-.0713c-.834,0-1.5089-.4609-1.5089-1.0315v-5.9258h-.6612v5.9258c0,.5679-.6749,1.0315-1.5061,1.0315h-.0713c-.834,0-1.5089-.4609-1.5089-1.0315v-7.4045h-8.3263c.4691,6.4855,6.1069,11.3606,12.5896,10.8914,5.8325-.4225,10.469-5.0589,10.8914-10.8914h-8.3263.0055ZM27.9697,15.8075c-1.2483,0-2.2606-1.0123-2.2606-2.2606s1.0123-2.2606,2.2606-2.2606,2.2606,1.0123,2.2606,2.2606-1.0123,2.2606-2.2606,2.2606M28.0163,8.2301c-5.6789,0-10.5513,4.0548-11.5828,9.6404h23.1601c-1.0288-5.5856-5.8984-9.6404-11.5773-9.6404"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.391,20.8472v7.4045c0,.5679-.6749,1.0315-1.5089,1.0315h-.0686c-.834,0-1.5089-.4609-1.5089-1.0315v-5.9258h-.6612v5.9258c0,.5679-.6749,1.0315-1.5061,1.0315h-.0713c-.834,0-1.5089-.4609-1.5089-1.0315v-7.4045H.25c.4691,6.4855,6.1069,11.3606,12.5896,10.8914,5.8325-.4225,10.469-5.0589,10.8914-10.8914h-8.3428.0027ZM12.0029,15.8075c-1.2483,0-2.2606-1.0123-2.2606-2.2606s1.0123-2.2606,2.2606-2.2606,2.2606,1.0123,2.2606,2.2606-1.0123,2.2606-2.2606,2.2606M12.0029,8.2301C6.324,8.2301,1.4544,12.2849.4256,17.8706h23.1601c-1.0315-5.5911-5.9094-9.6487-11.5965-9.6404"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicareIcon);
export default __webpack_public_path__ + "static/media/communicare-icon.44702907c3a563db6e31d4f020a8d3a4.svg";
export { ForwardRef as ReactComponent };